import React from "react";
import help from "help/viewClusterDashboard.md"
import MarkdownHelpModal from "common/MarkdownHelpModal";

export const Help = () => (
  <MarkdownHelpModal
    title="Cluster Dashboard"
    source={help}
  />
);

export default Help;
